let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");
// let ProOnly = require("../../../../widgets/ProOnly");
let FormUtils = require("../../../../../utils/FormUtils");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let createStandardEventForm = require("../../createStandardEventForm");

module.exports = createStandardEventForm({
	eventToInitialValues(event){
		return {
			pd_rep_id: esUtils.toInt(event.pd_rep_id) > 0 ? event.pd_rep_id : null,
			sales_rep_id: esUtils.toInt(event.sales_rep_id) > 0 ? event.sales_rep_id : null,
			project_manager_id: esUtils.toInt(event.project_manager_id) > 0 ? event.project_manager_id : null
		};
	},
	buildSchema({Displaylists, is_limited_speaker}, data) {

		let schema = {
			pd_rep_id: {
				label: "PD Rep",
				type: "select",
				placeholder: "none -- direct",
				validate: FormUtils.v.optional,
				options: _.object(_.map(_.get(Displaylists, ["sitelists", "pd_reps"]), function(user) {
					return [user.id, user.fullname];
				}))
			},
			sales_rep_id: {
				label: "Sales Rep",
				type: "select",
				placeholder: "none -- direct",
				validate: FormUtils.v.optional,
				options: _.object(
						_.map(_.get(Displaylists, ["sitelists", "sales_reps"]), function(user) {
							return [user.id, user.fullname];
						}))
			},
			project_manager_id: {
				label: "Project Manager",
				type: "select",
				placeholder: "none -- direct",
				validate: FormUtils.v.optional,
				options: _.object(
						_.map(_.get(Displaylists, ["sitelists", "project_managers"]), function(user) {
							return [user.id, user.fullname];
						}))
			}
		};

		// If the PD Rep was archived and wouldn't show up in the drop down, then add it as an additional option
		if (!_.isNull(_.get(data,["pd_rep_id"])) && !_.contains(_.map(_.keys(_.get(schema,["pd_rep_id", "options"])), _.parseInt), _.get(data,["pd_rep_id"]))) {
			_.set(schema, ["pd_rep_id", "options", _.get(data,["pd_rep_id"])], _.get(_.indexBy(_.get(Displaylists, ["universal", "eusers", _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])]), "id"), [_.get(data,["pd_rep_id"]), "name"], _.get(data,["pd_rep_id"])));
		}
		// If the Sales Rep was archived and wouldn't show up in the drop down, then add it as an additional option
		if (!_.isNull(_.get(data,["sales_rep_id"])) && !_.contains(_.map(_.keys(_.get(schema,["sales_rep_id", "options"])), _.parseInt), _.get(data,["sales_rep_id"]))) {
			_.set(schema, ["sales_rep_id", "options", _.get(data,["sales_rep_id"])], _.get(_.indexBy(_.get(Displaylists, ["universal", "eusers", _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])]), "id"), [_.get(data,["sales_rep_id"]), "name"], _.get(data,["sales_rep_id"])));
		}
		// If the Project Manager was archived and wouldn't show up in the drop down, then add it as an additional option
		if (!_.isNull(_.get(data,["project_manager_id"])) && !_.contains(_.map(_.keys(_.get(schema,["project_manager_id", "options"])), _.parseInt), _.get(data,["project_manager_id"]))) {
			_.set(schema, ["project_manager_id", "options", _.get(data,["project_manager_id"])], _.get(_.indexBy(_.get(Displaylists, ["universal", "eusers", _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])]), "id"), [_.get(data,["project_manager_id"]), "name"], _.get(data,["project_manager_id"])));
		}

		return schema;
	},
	writeInputDataToEvent(data, event){
		event.pd_rep_id = esUtils.toInt(data.pd_rep_id);
		event.sales_rep_id = esUtils.toInt(data.sales_rep_id);
		event.project_manager_id = esUtils.toInt(data.project_manager_id);
	},
	renderFields(){
		// let {event} = this.props;
		// return ProOnly({sids: event.sids}, ezHorizontalFields(this));
		// allow everyone to edit the bureau 01/19/18 - redheadedstep
		return ezHorizontalFields(this);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/SalesRep.js